<template v-slot:activator="{ attrs }">
    <component :is="component" :value="value" :items="items" :item-text="itemText" :item-value="itemValue" :menu-props="menuProps" :prepend-icon="prependIcon" :label="label" multiple persistent-hint return-object @change="changed" v-bind="$attrs">
        <template v-if="maxShown == 0" v-slot:selection="{ index }">
            <span v-if="value.length == 1">&nbsp;{{ tb('(1 opção selecionada)') }}</span>
            <span v-else-if="index == 0"> &nbsp;({{ $t('orders.additionalInfo.manySelected', { count: value.length }) }}) </span>
        </template>
        <template v-else v-slot:selection="{ item, index }">
            <span v-if="index < maxShown">{{ item.type }} &nbsp;</span>
            <span v-if="index === maxShown" class="grey--text caption">(+{{ value.length - maxShown }} {{ $t('inputs.types') }})</span>
        </template>
    </component>
</template>

<script>
export default {
    props: {
        component: {
            type: String,
            default: 'v-select',
        },
        value: Array,
        items: Array,
        itemText: String,
        itemValue: {
            type: String,
            default: '',
        },
        menuProps: Object,
        prependIcon: String,
        label: String,
        maxShown: {
            type: Number,
            default: 0,
        },
    },

    methods: {
        changed(value) {
            this.$emit('selection-change', value);
        },
    },
};
</script>
